import React from 'react';
import { Typography, Link } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkIcon from '@mui/icons-material/Link';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useUserContext } from '../../context';
import './index.scss';

function ProfileLinks() {
  const { userData } = useUserContext();

  return (
    <div className="profile-links">
      {userData.location && (
        <Typography variant="body2" className="profile-link">
          <LocationOnIcon fontSize="small" />
          {userData.location}
        </Typography>
      )}
      {userData.website && (
        <Link href={`https://${userData.website}`} className="profile-link" target="_blank">
          <LinkIcon fontSize="small" />
          {userData.website}
        </Link>
      )}
      {userData.twitter && (
        <Link href={`https://twitter.com/${userData.twitter.substring(1)}`} className="profile-link" target="_blank">
          <TwitterIcon fontSize="small" />
          {userData.twitter}
        </Link>
      )}
      {userData.linkedin && (
        <Link href={`https://linkedin.com/${userData.linkedin}`} className="profile-link" target="_blank">
          <LinkedInIcon fontSize="small" />
          {userData.linkedin}
        </Link>
      )}
    </div>
  );
}

export default ProfileLinks;
